import CollectionModule from 'client/store/modules/CollectionModule';
import CommandResultsApi from 'client/api/v2/CommandResultsApi';

export const createCommandResultsCollection = () => {
  const collection = new CollectionModule(CommandResultsApi, '_id');
  const commandResultCollectionModule = collection.extractModule();

  const getInitialState = () => {
    const { state } = commandResultCollectionModule;
    return {
      ...state,
    };
  };

  return {
    namespaced: true,

    state: getInitialState(),

    getInitialState,

    actions: {
      ...commandResultCollectionModule.actions,
    },

    getters: {
      ...commandResultCollectionModule.getters,

      getItemsToBind(state = { features: { selectedItems: { ids: [] } } }) {
        return state.features.selectedItems.ids.map(item => ({ id: item }));
      },
    },

    mutations: {
      ...commandResultCollectionModule.mutations,
    },

  };
};

export default createCommandResultsCollection();
